import React, { useState, useEffect } from 'react';
import { Box, Container, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { ArrowDropUp, ArrowDropDown } from '@mui/icons-material';
import PageHeader from '../common/banner/pageHeader';
import ClassificationBannerHeader from '../common/banner/classifactionBannerHeader';
import { toast } from 'react-toastify';
import { sortAdminItems } from '../common/utils/tableUtil';
import SearchBar from '../common/search/SearchBar';

const InventoryTable = ({ items, sortConfig, onSortChange }) => {

  const handleSort = (key) => {
    const direction =
      sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    onSortChange({ key, direction });
  };

  const SortIcon = ({ field }) => {
    if (sortConfig.key !== field) return null;
    return sortConfig.direction === 'asc' ? (
      <ArrowDropUp fontSize="small" />
    ) : (
      <ArrowDropDown fontSize="small" />
    );
  };

  return (
    <>
      <TableContainer component={Paper} sx={{ mt: 4 }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">    
          <TableHead>
            <TableRow sx={{ backgroundColor: '#0568AE' }}>
              {['IP', 'DNS', 'MAC Address', 'Manufacturer', 'Type', 'Operating System', 'Collector', 'Ports', 'Scan Date'].map((field) => (
                <TableCell
                  key={field}
                  onClick={() => handleSort(field)}
                  sx={{ color: '#EEEEEE', fontWeight: 'bold', cursor: 'pointer', userSelect: 'none' }}
                >
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <span>{field.charAt(0).toUpperCase() + field.slice(1)}</span>
                    <SortIcon field={field} />
                  </Stack>
                </TableCell>                
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item, index) => (
              <TableRow key={item.id} sx={{ height: 56, backgroundColor: index % 2 === 0 ? '#2A2A2A' : '#000000' }}>
                <TableCell sx={{ color: '#FFFFFF' }}>{item.ip}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{item.dns}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{item.macaddress}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{item.manufacturer}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{item.type}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{item.os}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{item.collector}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{item.ports}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{item.scandate}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default function Inventory() {
  const [inventory, setInventory] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'asc' });
  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    fetchInventory();
  }, []);

  const fetchInventory = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/inventory/`);    
      if (!response.ok) {
          toast.error(`HTTP error! status: ${response.status}`);
      } else {
          const json = await response.json();
          setInventory(json.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleSortChange = (newConfig) => {
    setSortConfig(newConfig);
  };

  const filtered = inventory.filter((item) => {
    const s = searchQuery.toLowerCase();
    return ['ip', 'dns', 'macaddress', 'manufacturer', 'type', 'os', 'collector', 'ports'].some((field) => item[field]?.toLowerCase().includes(s));
  });

  const sorted = sortAdminItems(filtered, sortConfig);
  const paginated = sorted.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
        <Box sx={{pt: 2}}>
            <ClassificationBannerHeader />
            <PageHeader title="Device Inventory" />
            <Stack direction="row" justifyContent="flex-end" mt={2} mb={1} sx={{ width: '100%', mx: 'auto' }}>                    
                  <SearchBar
                      value={searchQuery}
                      onChange={setSearchQuery}
                      placeholder="Search applications..."
                      label="Filter"
                      width={200}
                  />                
            </Stack>
          
            <TableContainer component={Paper} sx={{ mt: 4, backgroundColor: '#1A1A1A'  }}>
                <InventoryTable
                    items={paginated}
                    sortConfig={sortConfig}
                    onSortChange={handleSortChange}
                    setInventory={setInventory}
                />
                <TablePagination
                    component="div"
                    count={sorted.length}
                    page={page}
                    onPageChange={(e, newPage) => setPage(newPage)}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={(e) => { setRowsPerPage(+e.target.value); setPage(0); }}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    sx={{ color: 'white', '& .MuiSvgIcon-root': { color: 'white' } }}
                />
            </TableContainer>
        </Box>
    </Container>
  );
}